import React from 'react';
import './_custom-checkbox.scss';

export default function CustomCheckbox({ checked, onChange, children, className = '', name = undefined }) {
  return (
    <label className={`CustomCheckbox ${className}`.trim()}>
      <input type="checkbox" name={name} checked={checked} onChange={onChange} />
      <span className="CustomCheckbox__custom">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3 9L8 14L21 2"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {children}
    </label>
  );
}
